export default __webpack_public_path__ + "static/media/iced_red_bean_drink.7080fdee.JPG";